<script>
    export let onSelectMode;

    function selectMode(mode) {
        onSelectMode(mode);
    }
</script>

<div class="mode-selector">
    <div class="mode-selector-header">
        <h2 class="text-base-content">Choisissez votre mode d'apprentissage</h2>
        <p class="text-base-content/70">Comment souhaitez-vous étudier ce deck ?</p>
    </div>

    <div class="mode-cards">
        <button class="mode-card bg-base-200 hover:bg-base-300" on:click={() => selectMode('spaced')}>
            <div class="mode-icon">📅</div>
            <h3 class="text-base-content">Sur plusieurs jours</h3>
            <p class="text-base-content/70">
                Révision espacée : les cartes sont proposées selon votre progression.
                Les cartes faciles reviendront dans 7 jours, moyennes dans 3 jours, difficiles le lendemain.
            </p>
            <div class="mode-badge badge badge-primary">Recommandé</div>
        </button>

        <button class="mode-card bg-base-200 hover:bg-base-300" on:click={() => selectMode('intensive')}>
            <div class="mode-icon">⚡</div>
            <h3 class="text-base-content">D'un seul coup</h3>
            <p class="text-base-content/70">
                Session intensive : les cartes sont proposées en boucle jusqu'à ce que vous les marquiez toutes comme faciles.
            </p>
        </button>
    </div>
</div>

<style>
    .mode-selector {
        display: flex;
        flex-direction: column;
        gap: 2rem;
        padding: 2rem 1rem;
        max-width: 800px;
        margin: 0 auto;
    }

    .mode-selector-header {
        text-align: center;
    }

    .mode-selector-header h2 {
        font-size: 1.5rem;
        font-weight: 600;
        margin: 0 0 0.5rem 0;
    }

    .mode-selector-header p {
        font-size: 1rem;
        margin: 0;
    }

    .mode-cards {
        display: grid;
        gap: 1.5rem;
        grid-template-columns: 1fr;
    }

    .mode-card {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        padding: 2rem;
        border-radius: 12px;
        border: 2px solid transparent;
        transition: all 0.2s ease;
        cursor: pointer;
        text-align: center;
    }

    .mode-card:hover {
        border-color: hsl(var(--p));
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    }

    .mode-icon {
        font-size: 3rem;
    }

    .mode-card h3 {
        font-size: 1.25rem;
        font-weight: 600;
        margin: 0;
    }

    .mode-card p {
        font-size: 0.95rem;
        line-height: 1.5;
        margin: 0;
    }

    .mode-badge {
        margin-top: 0.5rem;
    }

    @media (min-width: 640px) {
        .mode-cards {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 640px) {
        .mode-selector {
            padding: 1rem;
        }

        .mode-selector-header h2 {
            font-size: 1.25rem;
        }

        .mode-card {
            padding: 1.5rem;
        }

        .mode-icon {
            font-size: 2.5rem;
        }
    }
</style>
